<template>
    <div class="input-option">
        <div class="text left">{{ leftText }}</div>
        <input v-if="!isDetails" type="text" class="input" :value="value" @input="inputVal" :placeholder="placeholder" />
        <div class="input" v-if="isDetails">{{ value }}</div>
        <div class="border"></div>
        <div class="text right">{{ rightText }}</div>

    </div>
</template>
<script>
    export default {
        name: 'InputOption',
        props: {
            value: String,
            placeholder:{
                type: String,
                default:''
            },
            rightText:{
                type: String,
                default:''
            },
            leftText:{
                type: String,
                default:''
            },
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        methods:{
            inputVal(e){
                this.$emit('input',e.target.value)
            }
        },
    }
</script>
<style lang="scss" scoped>
    .input-option{
        display: flex;
        align-items: center;
        width: 100%;
        height: 45px;
        position: relative;
        .border {
            border: 1px solid #D6D3D3;
            height: 45px;
            position: absolute; left: 0; right: 0; top: 0; bottom: 0;
            z-index: -1;
        }
        .input{
            flex: 1;
            height: 96%;
            padding: 0 14px;
            display: flex;
            overflow: hidden;
            font-size: 15px;
            color: #222;
            align-items: center;
            border: none;
            &:focus + .border{
                border-color: #FFA307;
                outline: 0;
                box-shadow: inset 0 0 1px rgba(0,0,0,.075), 0 0 8px rgba(255, 163, 7,.1);
            }
        }
        .text{
            color: #222222;
            font-size: 15px;
            &.right{
                padding-right: 14px;
            }
            &.left{
                padding-left: 14px;
            }
        }
    }

</style>
